module.exports = __webpack_public_path__ + "static/media/bluePic.bcea7e21.jpg";